import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import axios from 'axios';

import { getCourseColor, getCourseIconPath } from '../../../../utils/course-utils';

import PopularCourseInfo from './PopularCourseInfo';
import CarouselButtons from './CarouselButtons';

const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 2000,
  nextArrow: <CarouselButtons.Next />,
  prevArrow: <CarouselButtons.Prev />,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const CoursesScreen = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    axios.get('/api/v1/courses/popular').then(response => {
      setCourses(response.data.courses);
    });
  }, []);

  return (
    <div className="courses-screen" id="courses-screen-container-id">
      <p className="landing-caption-dark">Most popular courses</p>
      <div className="courses-screen-slider-container">
        <Slider {...carouselSettings}>
          {courses.map(course => (
            <div key={course._id}>
              <PopularCourseInfo
                id={course._id}
                color={getCourseColor(course.type)}
                icon={getCourseIconPath(course.type)}
                title={course.name}
                description={course.description}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CoursesScreen;
